// Every distinct org location name. There is no top-level
// `orgMetaData.location`; each legal entity under
// `orgMetaData.organization_structure` carries its own `locations` array
// (e.g. `{ name: "US - USA" }`), and multiple legal entities can share the
// same location, so this dedupes on `name` across all entities (same source
// SbJdCreationDrawerV2/useJdForm.js reads per-entity). Shared by the
// aspiration form's Preferred Locations options (AspirationCaptureV2) and
// the pathways page's saved-aspiration hydration (TalentMobilityEmployeeV2:
// "does the saved list cover every org location?").
export const getOrgLocationNames = (orgMetaData) => {
  const entities = Array.isArray(orgMetaData?.organization_structure)
    ? orgMetaData.organization_structure
    : [];
  const names = entities
    .flatMap((entity) => (Array.isArray(entity.locations) ? entity.locations : []))
    .map((loc) => loc?.name)
    .filter(Boolean);
  return [...new Set(names)];
};
